import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { EMAILJS_CONFIG } from '../config/emailjs.config';

const CustomerForm = () => {
  const [formData, setFormData] = useState({
    mobile: '',
    name: '',
    email: '',
    vehicleNo: '',
    productType: 'SBI',
    location: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    // Template parameters matching your EmailJS template
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.mobile,
      message: `Vehicle: ${formData.vehicleNo} | Product: ${formData.productType} | Location: ${formData.location}`,
    };

    emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATES.CUSTOMER_FORM,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY
    )
      .then((response) => {
        console.log('Email sent successfully:', response);
        setSubmitted(true);
        setSending(false);
        setTimeout(() => {
          setSubmitted(false);
          setFormData({ mobile: '', name: '', email: '', vehicleNo: '', productType: 'SBI', location: '' });
        }, 3000);
      })
      .catch((error) => {
        console.error('Email send failed:', error);
        setError('Failed to send. Please try again or contact us directly.');
        setSending(false);
      });
  };

  return (
    <section id="customer-form" className="py-16 bg-neutral-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-neutral-900">
              Get Your FASTag Delivered Home
            </h2>
            <p className="text-xl text-neutral-600">
              In Just a Few Clicks - Simple, Fast, and Secure
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-start">
            <div className="bg-gradient-to-br from-secondary-500 to-secondary-700 text-white rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-6">Why Order Online?</h3>

              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 mr-4">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">Doorstep Delivery</h4>
                    <p className="text-secondary-100">FASTag delivered right to your home or office</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 mr-4">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">100% Paperless</h4>
                    <p className="text-secondary-100">No physical bank visits or lengthy paperwork</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 mr-4">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">Instant Processing</h4>
                    <p className="text-secondary-100">Quick verification and fast activation</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg p-3 mr-4">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">24/7 Support</h4>
                    <p className="text-secondary-100">Continuous assistance for all your queries</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <h4 className="font-semibold mb-2 text-lg">Choose Your Bank</h4>
                <div className="flex gap-4">
                  <div className="bg-white text-neutral-900 rounded-lg px-4 py-2 font-semibold">SBI</div>
                  <div className="bg-white text-neutral-900 rounded-lg px-4 py-2 font-semibold">IDFC First Bank</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <h3 className="text-2xl font-bold text-neutral-900 mb-6">Customer Registration Form</h3>

              {submitted ? (
                <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-6 text-center">
                  <svg className="w-16 h-16 text-secondary mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <h4 className="text-xl font-semibold text-secondary-800 mb-2">Order Received!</h4>
                  <p className="text-secondary-700">Your FASTag will be delivered to your location shortly. We'll contact you for confirmation.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  {error && (
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
                      <p className="text-red-700">{error}</p>
                    </div>
                  )}
                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="customer-mobile">
                      Mobile Number *
                    </label>
                    <input
                      type="tel"
                      id="customer-mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      pattern="[0-9]{10}"
                      placeholder="Enter 10-digit mobile number"
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-secondary focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="customer-name">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="customer-name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-secondary focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="customer-email">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="customer-email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email address"
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-secondary focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="customer-vehicle">
                      Vehicle Number *
                    </label>
                    <input
                      type="text"
                      id="customer-vehicle"
                      name="vehicleNo"
                      value={formData.vehicleNo}
                      onChange={handleChange}
                      placeholder="e.g., MH01AB1234"
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-secondary focus:border-transparent uppercase"
                    />
                  </div>

                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="customer-product">
                      Product Type *
                    </label>
                    <select
                      id="customer-product"
                      name="productType"
                      value={formData.productType}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-secondary focus:border-transparent"
                    >
                      <option value="SBI">SBI FASTag</option>
                      <option value="IDFC">IDFC First Bank FASTag</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-neutral-700 font-semibold mb-2" htmlFor="customer-location">
                      Location / Address *
                    </label>
                    <textarea
                      id="customer-location"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      rows="3"
                      placeholder="Enter your delivery address"
                      required
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-secondary focus:border-transparent"
                    ></textarea>
                  </div>

                  <div className="bg-primary-50 border border-primary-200 rounded-lg p-4">
                    <p className="text-sm text-neutral-700">
                      <strong>Total Cost:</strong> ₹400 (includes ₹200 refundable security deposit)
                    </p>
                  </div>

                  <button
                    type="submit"
                    disabled={sending}
                    className="w-full bg-gradient-to-r from-secondary-500 to-secondary-700 text-white py-4 rounded-lg font-semibold hover:from-secondary-600 hover:to-secondary-800 transition shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {sending ? 'Sending...' : 'Submit Order'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerForm;
